import { render, staticRenderFns } from "./PromotionProgress.vue?vue&type=template&id=4f47b7e4&scoped=true"
import script from "./PromotionProgress.vue?vue&type=script&lang=js"
export * from "./PromotionProgress.vue?vue&type=script&lang=js"
import style0 from "./PromotionProgress.vue?vue&type=style&index=0&id=4f47b7e4&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f47b7e4",
  null
  
)

export default component.exports